<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Pesquisar</h4>
                </md-card-header>
                <md-card-content>
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-size-50 md-small-size-100"
                        >
                            <md-field>
                                <label>Nome</label>
                                <md-input
                                    type="text"
                                    v-model="searchModel.name"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-50 md-small-size-100"
                        >
                            <md-field>
                                <label for="branch">Loja</label>
                                <md-select
                                    name="branch"
                                    id="branch"
                                    value="A"
                                    v-model="searchModel.branch"
                                >
                                    <md-option
                                        v-for="(branch, index) in branchesData"
                                        v-bind:key="`branch-${index}`"
                                        :value="branch.id"
                                    >
                                        {{ branch.name }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <md-button
                                class="md-simple md-sm"
                                @click="resetFilter()"
                            >
                                Limpar
                            </md-button>
                            <md-button
                                class="md-primary md-sm ml-1"
                                @click="applyFilter()"
                            >
                                Pesquisar
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header>
                    <div style="text-align: right">
                        <md-button
                            class="md-primary md-sm"
                            style="margin: 20px 20px 0 20px"
                            @click.native="create()"
                        >
                            Adicionar
                        </md-button>
                        <md-button
                            class="md-just-icon md-simple"
                            style="float:right; margin: 10px 0 0 0"
                            @click.native="handleColumnsEdit()"
                        >
                            <md-icon>settings</md-icon>
                        </md-button>
                    </div>
                </md-card-header>
                <md-card-content>
                    <md-table
                        :value="queriedData.results"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="customSort"
                        class="paginated-table table-striped table-hover"
                    >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell
                                v-for="column in visibleColumns"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                                :title="
                                    column == 'cluster_type' && item[column]
                                        ? clusterTypes[item[column]].description
                                        : item[column]
                                "
                            >
                                {{
                                    column == 'cluster_type' && item[column]
                                        ? clusterTypes[item[column]].name
                                        : item[column]
                                }}
                            </md-table-cell>
                            <md-table-cell md-label="Ações">
                                <md-button
                                    class="md-just-icon md-warning md-simple"
                                    @click="
                                        $router.push('/clusters/' + item.id)
                                    "
                                >
                                    <md-icon>edit</md-icon>
                                </md-button>
                                <md-button
                                    class="md-just-icon md-danger md-simple"
                                    @click.native="handleDelete(item)"
                                >
                                    <md-icon>close</md-icon>
                                </md-button>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando
                            {{ this.queriedData.results.length }} itens de um
                            total de {{ total }}.
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>

        <modal v-if="columnsModal" @close="columnsCancel()" width="250px">
            <template slot="header">
                <h4 class="modal-title">Colunas disponíveis</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="columnsCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div style="text-align: left">
                    <md-checkbox
                        v-for="column in Object.keys(showColumns)"
                        v-model="showColumns[column]"
                        :key="column"
                    >
                        {{ columnNames[column] }}
                    </md-checkbox>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-primary" @click="columnsCancel()">
                    OK
                </md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Pagination, Modal } from '@/components'
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'

import { Cluster as Model } from '@/models/cluster.model'
const model = 'clusters'

export default {
    created() {
        this.readEntities()
        this.readBranches()
        this.readClusterTypes()
    },
    components: {
        Pagination,
        Modal
    },
    computed: {
        ...mapState({
            queriedData: state => state[model].page,
            branchesData: state => state['branches'].nameIds,
            _clusterTypes: state => state['clusters'].clusterTypes
        }),
        to() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[
                    this.queriedData.results.length - 1
                ].id
            else return 0
        },
        from() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[0].id
            else return 0
        },
        total() {
            return this.queriedData.count
        },
        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        },
        clusterTypes() {
            let dict = {}
            this._clusterTypes.forEach(item => (dict[item.id] = item))
            return dict
        }
    },
    data() {
        return {
            viewModal: false,
            editModalTitle: '',
            editModalModel: new Model(),
            editModal: false,
            columnsModal: false,
            showColumns: Model.visibleFields,
            columnNames: Model.fieldNames,
            editableFields: Object.keys(Model.editableFields),
            fieldTypes: Model.fieldTypes,
            currentSort: 'id',
            currentSortOrder: 'asc',
            pagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            },

            searchModel: {
                name: null,
                branch: null
            }
        }
    },
    methods: {
        ...mapActions(model, {
            createEntity: 'create',
            readEntities: 'read',
            readClusterTypes: 'readClusterTypes',
            updateEntity: 'update',
            deleteEntity: 'delete'
        }),
        ...mapActions('branches', {
            readBranches: 'readNameIds'
        }),
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                try {
                    if (this.currentSortOrder === 'desc')
                        return a[sortBy].localeCompare(b[sortBy])
                    return b[sortBy].localeCompare(a[sortBy])
                } catch (e) {
                    return 0
                }
            })
        },
        handleColumnsEdit() {
            this.columnsModal = true
        },
        columnsCancel() {
            this.columnsModal = false
        },

        async create() {
            let cluster
            try {
                cluster = await this.createEntity({ name: 'Cluster sem nome' })
            } catch (error) {
                this.$notify({
                    message: 'Erro ao criar cluster.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            }
            this.$router.push('/clusters/' + cluster.id)
        },

        handleDelete(item) {
            Swal.fire({
                title: 'Certeza?',
                text: 'Esta ação é irreversível.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-danger btn-fill',
                cancelButtonClass: 'md-button md-simple',
                confirmButtonText: 'Sim, remover!',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
            }).then(async result => {
                if (result.value) {
                    let deleteError = await this.deleteEntity({ id: item.id })

                    if (deleteError)
                        this.$notify({
                            message: 'Erro ao remover.',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'danger'
                        })
                    else {
                        this.$notify({
                            message: 'Removido com sucesso!',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'success'
                        })
                        this.readEntities()
                    }
                }
            })
        },

        resetFilter() {
            this.searchModel.name = null
            this.searchModel.branch = null
        },
        applyFilter() {
            this.readEntities(this.searchModel)
            this.pagination.currentPage = 1
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                this.readEntities({ 
                    page: val.currentPage,
                    name: this.searchModel.name,
                    branch: this.searchModel.branch
                    })
            },
            deep: true
        }
    }
}
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
.modal-wrapper .md-checkbox {
    display: flex !important;
}
.md-table-cell {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
